import React, { useState, useEffect } from 'react';
import { apiCall } from '../components/ApiCalls';
import { ChefCard } from './ChefCard';
import { ChefDetail } from './ChefDetail';
import { Sidebar } from './Sidebar';
import { Chef, Recipe, EstablishmentType } from './types';
import './LocalFlavors.scss';

const LocalFlavorsPage: React.FC = () => {
  const [chefs, setChefs] = useState<Chef[]>([]);
  const [recipes, setRecipes] = useState<Recipe[]>([]);
  const [selectedChef, setSelectedChef] = useState<Chef | null>(null);
  const [selectedCuisine, setSelectedCuisine] = useState<string>('All');
  const [selectedEstablishmentType, setSelectedEstablishmentType] = useState<EstablishmentType | 'All'>('All');
  const [locationSearch, setLocationSearch] = useState<string>('');

  useEffect(() => {
    fetchChefs();
    fetchRecipes();
  }, []);

  const fetchChefs = async () => {
    try {
      const response = await apiCall<{}, Chef[]>({
        url: 'https://your-api-endpoint.com/chefs',
        method: 'GET',
      });
      if (response.isSuccess && Array.isArray(response.data)) {
        setChefs(response.data);
      }
    } catch (error) {
      console.error('Error fetching chefs:', error);
    }
  };
  
  const fetchRecipes = async () => {
    try {
      const response = await apiCall<{}, Recipe[]>({
        url: 'https://your-api-endpoint.com/recipes',
        method: 'GET',
      });
      if (response.isSuccess && Array.isArray(response.data)) {
        setRecipes(response.data);
      }
    } catch (error) {
      console.error('Error fetching recipes:', error);
    }
  };

  
  const filteredChefs = chefs.filter(chef => 
    (selectedCuisine === 'All' || chef.cuisine === selectedCuisine) &&
    (selectedEstablishmentType === 'All' || chef.establishment_type === selectedEstablishmentType)
  );

  const getChefRecipes = (chef: Chef) => {
    return recipes.filter(recipe => chef.recipe_ids.includes(recipe.recipe_id));
  };

  return (
    <div className="local-flavors-page">
     <Sidebar 
        cuisines={['All', ...new Set(chefs.map(chef => chef.cuisine))]}
        selectedCuisine={selectedCuisine}
        onSelectCuisine={setSelectedCuisine}
        establishmentTypes={['All', ...Object.values(EstablishmentType)]}
        selectedEstablishmentType={selectedEstablishmentType}
        onSelectEstablishmentType={setSelectedEstablishmentType}
        locationSearch={locationSearch}
        onLocationSearch={setLocationSearch}
      />
      <main className="content">
        {!selectedChef ? (
          <div className="chef-grid">
            {filteredChefs.map(chef => (
              <ChefCard 
                key={chef.id} 
                chef={chef} 
                recipes={getChefRecipes(chef)}
                onClick={() => setSelectedChef(chef)} 
              />
            ))}
           <div className="under-construction">
              <svg viewBox="0 0 500 500" className="under-construction-svg">
                <defs>
                  <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#f2f2f2" />
                    <stop offset="100%" stopColor="#e6e6e6" />
                  </linearGradient>
                </defs>

                <rect x="0" y="0" width="500" height="500" fill="url(#gradient)" />

                <g transform="translate(100, 100)">
                  <path
                    d="M300,50 C300,22.3857625 277.614237,0 250,0 L50,0 C22.3857625,0 0,22.3857625 0,50 L0,300 C0,327.614237 22.3857625,350 50,350 L250,350 C277.614237,350 300,327.614237 300,300 L300,50 Z"
                    fill="#333"
                  />
                  <text x="50" y="200" fontSize="60" fill="#fff" fontWeight="bold">
                    Under
                  </text>
                  <text x="50" y="280" fontSize="60" fill="#fff" fontWeight="bold">
                    Construction
                  </text>
                </g>
              </svg>
            </div>
          
          </div>
        ) : (
          <ChefDetail 
            chef={selectedChef} 
            recipes={getChefRecipes(selectedChef)}
            onBack={() => setSelectedChef(null)} 
          />
        )}
      </main>
    </div>
  );
};

export default LocalFlavorsPage;